import styled from 'styled-components'

export const List = styled.ul`
	font-size: 12px;
	list-style: none;
	margin: 0;
	padding: 0;
`
